<script lang="ts">
    import { calculateWeapons } from "./weapon";
    import { Character, characterStore } from "../character/character";
    import WeaponType from "./WeaponType.svelte";
    import AttributeRow from "../attribute/AttributeRow.svelte";
import LevelInput from "../levelup/LevelInput.svelte";

    let character: Character;

    characterStore.subscribe((char) => {
        console.log("Weapon.subscribe", char);
        char.weapons = calculateWeapons(char)

        character = char;
    });

</script>

        <h1>Waffen</h1>
        <table>
            
            <thead>
                <th>WaffenTyp</th>
                <th>ID</th>
                <th>Name</th>
                <th>Rang</th>
                <th>Objekt</th>
                <th>Spezial</th>
                <th>Total</th>
            </thead>
            
            <tbody>
                {#each character.weapons as weapon, i}

                <tr class="font-bold">
                    <td>
                        <WeaponType
                            i = {i}
                            character={character}
                            weaponType={weapon.weaponType} >
                        </WeaponType>
                    </td>

                    <AttributeRow 
                        editEnabled={true}
                        attribute={weapon.group.attribute}
                        changeFn={() => characterStore.set(character)}>
                    </AttributeRow>

                            <!--

                    <LevelInput 
                        level={weapon.group.attribute.level}
                        changeFn={(lvl) => {
                            weapon.group.attribute.level = lvl;
                            characterStore.set(character)
                        } } 
                        costs={weapon.group.costs}>
                    </LevelInput>

                -->
                </tr>


                    {#each weapon.group.attributes as attribute}
                        <tr>
                            <td></td>
                            <AttributeRow 
                                editEnabled={true}
                                attribute={attribute}
                                changeFn={() => characterStore.set(character)}>
                            </AttributeRow>
                            <!--
                            <LevelInput 
                                level={attribute.level}
                                changeFn={(lvl) => {
                                    attribute.level = lvl;
                                    characterStore.set(character)
                                }} 
                                costs={weapon.group.costs}>
                            </LevelInput>
                            -->
                        </tr>
                    {/each}
                {/each}

            </tbody>

        </table>

